const ROUTE = 'app/PartnerRegistration';
export const FETCH_COUPLES_INFO = `${ROUTE}/FETCH_COUPLES_INFO`;
export const FETCH_COUPLES_INFO_SUCCESS = `${ROUTE}/FETCH_COUPLES_INFO_SUCCESS`;
export const FETCH_COUPLES_INFO_ERROR = `${ROUTE}/FETCH_COUPLES_INFO_ERROR`;

export const CONFIRM_CONSENT_INFO = `${ROUTE}/CONFIRM_CONSENT_INFO`;
export const CONFIRM_CONSENT_INFO_SUCCESS = `${ROUTE}/CONFIRM_CONSENT_INFO_SUCCESS`;
export const CONFIRM_CONSENT_INFO_ERROR = `${ROUTE}/CONFIRM_CONSENT_INFO_ERROR`;
